import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { FachverfahrenSlice } from "./types";

const initialState: FachverfahrenSlice = {
	loaded: false,
	manifests: {}
};

export const {
	name: fachverfahrenSliceName,
	actions: { setFachverfahren: setFVManifests },
	reducer: fachverfahrenReducer
} = createSlice({
	name: "fachverfahren",
	initialState,
	reducers: {
		setFachverfahren(state, action: PayloadAction<FachverfahrenSlice["manifests"]>) {
			return {
				loaded: true,
				manifests: action.payload
			};
		}
	}
});
